import { createContext, useContext } from "react";

export const SelectionContext = createContext(null);

export const useSelection = () => {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error("Selection component should be within SelectionLayout!");
  }
  return context;
};
